import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { connect } from 'react-redux';
import { Grid, TableRow, TableBody, Table, TableCell, TableHead, Button, Icon, Card, Typography, LinearProgress } from 'material-ui';
import jsPDF from 'jspdf';
import moment from 'moment';
import icon_excel from '../../resources/images/icon_excel.png';
import icon_pdf from '../../resources/images/icon_pdf.png';
import SimpleBarChart from '../chartComponents/SimpleBarChart';
import ReactExport from "react-data-export";
import ExcelColumn from 'react-data-export/dist/ExcelPlugin/elements/ExcelColumn';
import { loadData } from '../../controllers/results/peopleByProvince';
import { getFilterText, setHeader, setGraphic, setTable, setFooter } from '../../utils/utils';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class PeopleByProvince extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            downloading: false,
            title: "Gráfica de distribución de persoas por provincias",
            data: [],
            excellData: {
                columns: [],
                data: []
            },
            total: 0,
            headers: [{
                label: "Comunidade",
                key: "name"
            }, {
                label: "Nº de persoas",
                key: "personas"
            }],
            filter: {
                from: moment().subtract(3, 'month').format('DD/MM/YYYY HH:mm'),
                to: moment().format('DD/MM/YYYY HH:mm'),
                selectedProvinces: [],
                office: -1
            },
            vertical: true,
            filename: "distribución_por_provincia_" + moment().format('DD-MM-YYYY')
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.loadData();
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const { sessionData } = this.props.main;
        const { filter } = this.props;
        let { data } = this.state;
        data = await loadData(data, sessionData, filter);
        this.setState(data);
        this.setState({ loading: false });
    }

    setLogoutAlert = (open) => {
        this.setState({ open: open });
    }

    exportPdf = async () => {
        this.setState({ downloading: true });
        try {
            const { offices, municipalities } = this.props.main;
            const { filter } = this.props;
            const { title } = this.state;
            let doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            let filter_text = getFilterText(filter, municipalities, offices);
            setHeader(doc, title, `Período: ${filter.from} a ${filter.to} ${filter_text}`);
            await setGraphic(doc, `graphic`);
            await setTable(doc, `tableAux`);
            setFooter(doc, 1, 1);
            doc.save(this.state.filename);
        } catch (err) {
            console.error(err);
        }
        this.setState({ downloading: false });
    }

    setVertical = () => {
        this.setState({ vertical: !this.state.vertical });
    }

    render() {
        const { data, total, vertical, filename, excellData, loading, downloading } = this.state;
        let buildData;
        if (data){
            buildData = data.sort((a,b) => (a.personas > b.personas) ? -1 : ((b.personas > a.personas) ? 1 : 0));
        }
        return (
            <Fragment>
                <Grid item xs={12} style={{ marginTop: '-8.5em' }}>
                    <Grid container spacing={16}>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={4} >
                            <div style={{ flexDirection: 'column', alignItems: 'right' }}>
                                <Button disabled={downloading} style={{
                                    backgroundColor: "#DDD",
                                    marginTop: '0.5em',
                                    marginRight: '1em',
                                    float: 'right'
                                }} onClick={this.exportPdf}>
                                    Exportar pdf<Icon>
                                        <img src={icon_pdf} alt="Exportar como pdf" />
                                    </Icon>

                                </Button>
                                <ExcelFile filename={filename} element={
                                    <Button style={{
                                        backgroundColor: "#DDD",
                                        marginTop: '0.5em',
                                        marginRight: '1em',
                                        float: 'right'
                                    }}>
                                        Exportar excel <Icon>
                                            <img src={icon_excel} alt="Exportar como excel" />
                                        </Icon>
                                    </Button>
                                }>
                                    <ExcelSheet data={excellData.data} name="Estadísticas por comunidade">
                                        {excellData.columns.map(column => {
                                            return (<ExcelColumn key={`${excellData.key}_${column.value}`} label={column.label} value={column.value} />);
                                        })}
                                    </ExcelSheet>
                                </ExcelFile>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                {loading ?
                    <Card style={{ width: '100%' }}>
                        <Typography variant="headline" component="h4">Cargando resultados...</Typography>
                        <LinearProgress />
                    </Card>
                    :
                    <React.Fragment>
                        <Grid item xs={12} md={9} xl={8}>
                            <SimpleBarChart
                                data={buildData}
                                dataKeyX="province_name"
                                dataKeyY="personas"
                                typeX="category"
                                typeY="number"
                                vertical={vertical}
                                minHeight={580}
                                barColor="#8884d8" />
                        </Grid>
                        <Grid item xs={12} md={3} xl={4} style={{ textAlign: 'center' }}>
                            <Button onClick={this.setVertical}>{vertical === true ? 'Vista vertical' : 'Vista horizontal'}</Button>
                            <div style={{ margin: '0 1em' }}>
                                <Table id="tableAux">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ padding: '3px 0px 3px 2px' }}>Provincia</TableCell>
                                            <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>Visitantes</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((item) => {
                                            return (
                                                <TableRow style={{ height: '40px' }} key={`province_${item.province_id}`}>
                                                    <TableCell style={{ padding: '3px 0px 3px 2px' }}>{item.province_name}</TableCell>
                                                    <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>{item.personas}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        <TableRow style={{ fontWeight: 'bold' }}>
                                            <TableCell style={{ padding: '3px 0px 3px 2px' }}>Total</TableCell>
                                            <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>{total}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </div>
                        </Grid>
                    </React.Fragment>
                }
            </Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleByProvince);



// WEBPACK FOOTER //
// ./src/components/SurveyResults/PeopleByProvince.js